import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const inputVariants = cva(
  "flex items-center w-full px-[2.25rem] file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-white placeholder:text-opacity-60 disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      theme: {
        default: "p-normal text-white transition-colors rounded-[.75rem] py-[1.875rem] focus:outline outline-1 outline-offset-[5px] border border-white border-opacity-20 bg-white bg-opacity-5 before:-inset-[.5rem] before:rounded-[inherit] before:absolute before:border before:border-white !py-[1.5rem] !bg-white/5 border border-white/10",
        new: "text-[2.25rem] min-h-[7rem] !outline-none bg-white/5 border border-white/20 focus:border-white/40 transition-all",
      },
    },
    defaultVariants: {
      theme: "default",
    },
  }
)

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement>,
    VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, theme, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(inputVariants({ theme }), className)}
        style={theme === "default" ? { outlineColor: "rgba(255, 255, 255, 0.07)" } : undefined}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
